export enum MapLayerEnum {
  TIANDITU_LAYER = 'TIANDITU_LAYER', // 天地图底图
  TIANDITU_MARK_LAYER = 'TIANDITU_MARK_LAYER', // 天地图标记
  TRAVEL_ROUTE_LAYER = 'TRAVEL_ROUTE_LAYER', //行驶线路
  START_REALTIME_POINT_LAYER = 'START_REALTIME_POINT_LAYER', // 起点和车辆实时位置点的图层
  TECENTMAP_LAYER = 'TECENTMAP_LAYER', // 腾讯地图

  CENTER_LINE = 'CENTER_LINE', // 车道中心线
  INTERSECTION = 'INTERSECTION', // 路口
  OPEN_AREA = 'OPEN_AREA', // 开阔区域
  LINE_BOUNDARY = 'LINE_BOUNDARY', // 车道变线
  STOP_LINE = 'STOP_LINE', // 停止线
  GATE_LAYER = 'GATE_LAYER', // 大门
  POINTS_LAYER = 'POINTS_LAYER', //点位
  POINTS_NAME_LAYER = 'POINTS_NAME_LAYER', //点位名称
  PLANNED_ROUTE_LAYER = 'PLANNED_ROUTE_LAYER', //采图线路
  CENTERPOINT_LAYER = 'CENTERPOINT_LAYER', // 中心点
  SELECT_POINTS_LAYER = 'SELECT_POINTS_LAYER', // 选中点位的图层
  SCHEDULED_ROUTE_LAYER = 'SCHEDULED_ROUTE_LAYER', // 调度规划线路
  FINISHED_ROUTE_LAYER = 'FINISHED_ROUTE_LAYER', // 已完成线路
}

export enum TravelStatus {
  SKIP = 'SKIP',
  INIT = 'INIT',
  START = 'START',
  ARRIVED = 'ARRIVED',
  DEPART = 'DEPART',
  STAY = 'STAY',
}

export enum ScheduleStateEnum {
  UNKNOWN = 'UNKNOWN',
  WAITING = 'WAITING',
  ALREADY = 'ALREADY',
  SETOUT = 'SETOUT',
  DELIVERY = 'DELIVERY',
  RETURN = 'RETURN',
  ARRIVED = 'ARRIVED',
  TOLOAD = 'TOLOAD',
  LOADING = 'LOADING',
  TOUNLOAD = 'TOUNLOAD',
  UNLOADING = 'UNLOADING',
  INITIAL = 'INITIAL',
  ASSIGNED = 'ASSIGNED',
  COLLECTING = 'COLLECTING',
}

/**
 * 通用枚举的key枚举
 * 用于给get_enum_list_map接口提供入参key以获取对应的枚举list
 * @export
 * @enum {number}
 */
export enum CommonEnumKey {
  // ----------事故单部分----------
  NEW_ACCIDENT_LEVEL_ENUM = 'NEW_ACCIDENT_LEVEL_ENUM', // 事故等级分类（即技术支持定级）
  ACCIDENT_RESPONSIBLE_ENUM = 'ACCIDENT_RESPONSIBLE_ENUM', // 技术支持判定的有责无责
  THOROUGH_ACCIDENT_TYPE_ENUM = 'THOROUGH_ACCIDENT_TYPE_ENUM', // 事故分类枚举

  ALARM_EVENT_ENUM = 'ALARM_EVENT_ENUM',
  ISSUE_STATE_ENUM = 'ISSUE_STATE_ENUM',
  SYSTEM_STATE_ENUM = 'SYSTEM_STATE_ENUM',
  VEHICLE_STATE_ENUM = 'VEHICLE_STATE_ENUM',
  SCHEDULE_STATE_ENUM = 'SCHEDULE_STATE_ENUM',
  ACCIDENT_LEVEL_ENUM = 'ACCIDENT_LEVEL_ENUM',
  BUG_SEVERITY_ENUM = 'BUG_SEVERITY_ENUM',
  BUG_MODULE_ENUM = 'BUG_MODULE_ENUM',
  MANUAL_ALARM_SOURCE_ENUM = 'MANUAL_ALARM_SOURCE_ENUM',
  COCKPIT_MODE_ENUM = 'COCKPIT_MODE_ENUM',
}

export const TakeOverProcessStatus = {
  NULL: null as null,
  ENTER_TAKE_OVER_PROCESS: 'ENTER_TAKE_OVER_PROCESS' as const,
  ENTER_TAKE_OVER_SUCCESS: 'ENTER_TAKE_OVER_SUCCESS' as const,
  ENTER_TAKE_OVER_FAIL: 'ENTER_TAKE_OVER_FAIL' as const,
  EXIT_TAKE_OVER_PROCESS: 'EXIT_TAKE_OVER_PROCESS' as const,
  EXIT_TAKE_OVER_FAIL: 'EXIT_TAKE_OVER_FAIL' as const,
} as const;

export enum CockpitRealtimeErrorCode {
  ERROR_VEHICLE_AEB_IS_TRUE = -10009, // aeb制动
}

/**
 * worker消息的类型枚举
 *
 * @enum {number}
 */
export enum WorkerStateType {
  READY = 'READY',
  CREATING = 'CREATING',
  ERROR = 'ERROR',
}
